import React from 'react'
import * as S from './ReceivementProductWrapper.styles'
import { BadgeByStatus } from '../ReceivementTables/types'
import { ReceivementField } from '../ReceivementField'

interface Props {
    status?: keyof typeof BadgeByStatus;
    buyer?: string;
    orderBuyerName?: string;
}

const ReceivementProductWrapper: React.FC<Props> = ({
  children, status, buyer, orderBuyerName,
}) => {
  const { color, text } = status ? BadgeByStatus[status] : { color: '#fafafa', text: '' }

  return (
    <>
      {status && (
        <S.Container>
          <S.Badge style={{ backgroundColor: color }}><S.BadgeText>{text}</S.BadgeText></S.Badge>
            {orderBuyerName && <ReceivementField field='Comprador:' value={orderBuyerName}/> }
            {buyer && <ReceivementField field='Conferente da nota:' value={buyer}/> }
        </S.Container>
      )}
      <S.ChildrenContainer style={{ backgroundColor: color, borderColor: color }}>
        {children}
      </S.ChildrenContainer>
    </>
  )
}

export { ReceivementProductWrapper }
